// =============================================================================
//  NETWORK CONFIG  —  THIS IS THE ONLY PLACE YOU CHOOSE THE NETWORK.
//  Flip ACTIVE_NETWORK between "MAINNET" and "TESTNET".
//  The UI NEVER shows which one is active. Do not surface this to users.
// =============================================================================

// 👉  CHANGE THIS ONE LINE TO SWITCH NETWORKS  👈
export const ACTIVE_NETWORK = "MAINNET";

// Internal network definitions. (Labels here are for code only — never rendered.)
const NETWORKS = {
  MAINNET: {
    chainId: 56,
    chainIdHex: "0x38",
    chainName: "BNB Smart Chain",
    nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
    rpcUrls: ["https://bsc-dataseed.binance.org/", "https://bsc-dataseed1.defibit.io/"],
    blockExplorerUrls: ["https://bscscan.com"],
  },
  TESTNET: {
    chainId: 97,
    chainIdHex: "0x61",
    chainName: "BNB Smart Chain",
    nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
    rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
    blockExplorerUrls: ["https://bscscan.com"],
  },
};

export const NETWORK = NETWORKS[ACTIVE_NETWORK];

// Convenience exports used across the app.
export const REQUIRED_CHAIN_ID = NETWORK.chainId;
export const REQUIRED_CHAIN_ID_HEX = NETWORK.chainIdHex;

// Params object for wallet_addEthereumChain.
export const ADD_CHAIN_PARAMS = {
  chainId: NETWORK.chainIdHex,
  chainName: NETWORK.chainName,
  nativeCurrency: NETWORK.nativeCurrency,
  rpcUrls: NETWORK.rpcUrls,
  blockExplorerUrls: NETWORK.blockExplorerUrls,
};
